import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { memo } from "react";
import { Group, Text } from "@mantine/core";
import { useAuth } from "../../auth";
import { useGetUserEligibleGlobalMarketplaceFeeCampaignsQuery } from "../queries/marketplace.graphql.generated";
// TODO: use theme colors from base-components instead of hardcoding
const Pill = ({ text }) => {
    return (_jsxs(Group, { bg: "#DCFAE6", c: "#17B26A", py: 8, px: 12, sx: {
            borderRadius: "9999px",
            border: "1px solid #17B26A",
        }, spacing: 8, position: "apart", my: 25, children: [_jsx(Text, { color: "#17B26A", children: text }), _jsx(Text, { color: "#17B26A", weight: 600, children: "\u2713" })] }));
};
export const MarketplaceFeeCampaignNavbar = memo(() => {
    var _a, _b;
    const { authenticated, walletAddress, loading } = useAuth();
    const { data: marketplaceFeesData } = useGetUserEligibleGlobalMarketplaceFeeCampaignsQuery();
    if (loading)
        return null;
    if (!walletAddress || !authenticated)
        return null;
    if (!((_a = marketplaceFeesData === null || marketplaceFeesData === void 0 ? void 0 : marketplaceFeesData.getUserEligibleGlobalMarketplaceFeeCampaigns) === null || _a === void 0 ? void 0 : _a.length))
        return null;
    return (_jsx(Pill, { text: (_b = marketplaceFeesData === null || marketplaceFeesData === void 0 ? void 0 : marketplaceFeesData.getUserEligibleGlobalMarketplaceFeeCampaigns[0].appMessage) !== null && _b !== void 0 ? _b : "" }));
});
